import React from 'react';
import {
  FaChevronRight,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaTwitter,
  FaYoutube,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const FooterNine = () => {
  // Function to handle smooth scrolling to sections
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <>
      {/* footer area start */}
      <footer className="footer-area footer-area-2 footer-area-9  bg-gray mt-0 pd-top-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="widget widget_about">
                <div className="thumb">
                  <img 
                    src="assets/img/firmascheck-logo.png" 
                    alt="FirmasCheck - Firma electrónica segura" 
                    style={{maxHeight: '70px', width: 'auto'}}
                  />
                </div>
                <div className="details">
                  <p>
                    Firma electrónica sencilla y segura, con validación real de identidad.
                  </p>
                  <div className="contact-info mt-4">
                    <p><strong>contacto@firmascheck.cl</strong></p>
                  </div>
                  <div className="footer-login-wrap mt-4">
                    <a
                      href="https://app.firmascheck.cl"
                      className="btn btn-base footer-login-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ingresar
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 ps-xl-5">
              <div className="widget widget_nav_menu">
                <h4 className="widget-title">Navegación</h4>
                <ul>
                  <li>
                    <button 
                      onClick={() => scrollToSection('producto')}
                      className="section-jump-link footer-section-link text-start"
                    >
                      <FaChevronRight className="mb-1" /> Producto
                    </button>
                  </li>
                  <li>
                    <button 
                      onClick={() => scrollToSection('como-funciona')}
                      className="section-jump-link footer-section-link text-start"
                    >
                      <FaChevronRight className="mb-1" /> Cómo funciona
                    </button>
                  </li>
                  <li>
                    <button 
                      onClick={() => scrollToSection('seguridad')}
                      className="section-jump-link footer-section-link text-start"
                    >
                      <FaChevronRight className="mb-1" /> Seguridad
                    </button>
                  </li>
                  <li>
                    <button 
                      onClick={() => scrollToSection('precios')}
                      className="section-jump-link footer-section-link text-start"
                    >
                      <FaChevronRight className="mb-1" /> Precios
                    </button>
                  </li>
                  <li>
                    <button 
                      onClick={() => scrollToSection('faq')}
                      className="section-jump-link footer-section-link text-start"
                    >
                      <FaChevronRight className="mb-1" /> FAQ
                    </button>
                  </li>
                  <li>
                    <button 
                      onClick={() => scrollToSection('contacto')}
                      className="section-jump-link footer-section-link text-start"
                    >
                      <FaChevronRight className="mb-1" /> Contáctanos
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 ps-xl-5">
              <div className="widget widget_nav_menu">
                <h4 className="widget-title">Legal</h4>
                <ul>
                  <li>
                    <Link to="/terminos">
                      <FaChevronRight className="mb-1" /> Términos y Condiciones
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacidad">
                      <FaChevronRight className="mb-1" /> Política de Privacidad
                    </Link>
                  </li>
                  <li>
                    <Link to="/seguridad">
                      <FaChevronRight className="mb-1" /> Política de Seguridad
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="widget widget-recent-post">
                <h4 className="widget-title">Contacto</h4>
                <div className="widget widget_contact">
                  <ul className="details">
                    <li>
                      <FaMapMarkerAlt />
                      Santiago, Chile
                    </li>
                    <li className="mt-2">
                      <FaEnvelope className="mb-1" /> contacto@firmascheck.cl
                    </li>
                  </ul>
                  <ul className="social-media mt-4">
                    <li>
                      <Link to="#">
                        <FaFacebookF />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <FaTwitter />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <FaInstagram />
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <FaYoutube />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-md-6 align-self-center">
                <p>© FirmasCheck 2024 | Todos los derechos reservados</p>
              </div>
              <div className="col-md-6 text-lg-end">
                <Link to="/terminos">Términos y Condiciones</Link>
                <Link to="/privacidad">Política de Privacidad</Link>
                <Link to="/seguridad">Seguridad</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* footer area end */}
    </>
  );
};

export default FooterNine;
